const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 31_536_000],
  ['month', 2_592_000],
  ['week', 604_800],
  ['day', 86_400],
  ['hour', 3600],
  ['minute', 60],
];
const relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

export function timeAgo(iso: string): string {
  const seconds = Math.round((Date.parse(iso) - Date.now()) / 1000);
  for (const [unit, size] of UNITS) {
    if (Math.abs(seconds) >= size) return relative.format(Math.round(seconds / size), unit);
  }
  return 'just now';
}

export const fullDate = (iso: string): string =>
  new Date(iso).toLocaleString('en', { dateStyle: 'medium', timeStyle: 'short' });

export function bytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export const shortRev = (id: string | null | undefined): string => (id ? id.replace(/^rev_/, '').slice(0, 8) : '—');

export const encodePath = (path: string): string => path.split('/').map(encodeURIComponent).join('/');

/** A revision message's first line is its title; anything after a blank line is its description. */
export function splitMessage(message: string): { title: string; body: string } {
  const [first = '', ...rest] = message.trim().split(/\r?\n/);
  return { title: first.trim() || 'Update', body: rest.join('\n').trim() };
}
